import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { isBizlyEmployeeEmail } from 'utils/isBizlyEmployeeEmail';
import { getUserTier, TEAM_ADMIN, useUser } from './userStore';

// Hook to handle PostHog user identification when user changes
export const usePostHogUserIdentification = () => {
    const posthog = usePostHog();
    const user = useUser();

    useEffect(() => {
        if (user.id && user.loaded && user.token) {
            posthog.identify(user.id?.toString(), {
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                teamId: user.team?.id,
                teamName: user.team?.name,
                isTeamAdmin: user.team?.role === TEAM_ADMIN,
                isBizlyEmployee: isBizlyEmployeeEmail(user.email),
                role: user.role,
                teamTier: getUserTier(user),
                referrer: user.team?.referrer,
            });
        }
    }, [
        user.id,
        user.loaded,
        user.token,
        user.email,
        user.firstName,
        user.lastName,
        user.team?.id,
        user.team?.name,
        user.team?.role,
        user.team?.tier,
        user.role,
        user.team?.referrer,
        posthog,
    ]);
};
